module.exports = __webpack_public_path__ + "img/5.5db8ea60.jpg";